import React, { useCallback } from 'react'
import { useAppSelector } from '@/redux/store'
import { selectAiSettingsEnabled } from '@/redux/ducks/tenantUser/settings'
import { useAiTextTransform as useLegacyAiTextTransform } from '@/modules/base/components/ai/text/transform'
import type { AiTextTransformProps } from '@ai-chat-widget-contracts/contracts'

type BridgeProps = Omit<AiTextTransformProps, 'runtime'>

const LegacyAiTextTransform = (props: BridgeProps) => {
  const { renderAiComponents } = useLegacyAiTextTransform(props)
  return <>{renderAiComponents()}</>
}

export const AiTextTransformLegacyBridge = (props: BridgeProps) => {
  const globallyEnabled = useAppSelector(selectAiSettingsEnabled)
  return <LegacyAiTextTransform {...props} enabled={props.enabled && globallyEnabled} />
}

export const useAiTextTransform = (props: BridgeProps) => ({
  renderAiComponents: useCallback(() => <AiTextTransformLegacyBridge {...props} />, [props]),
})
